import './Footer.scss';

function Footer() {
  return <footer>Developed by @jadeallencook</footer>;
}

export default Footer;
